//[注：] 发版前请确认此文件"生产模式"是否配置准确
const env = process.env

let ngConfig = {}; //桌面页模块跳转路由前缀及router base部分。
if (env.NODE_ENV === 'development'){  //---开发模式---
    ngConfig={
        //登录api地址
        userLogin:'http://www.snz.com:8080',
        supplierLogin:'http://www.snz.com:8080',
        //nav(顶部导航)桌面页路径
        desktopNav:'/desktop#/user',
        desktopSupplierNav:'/desktop#/supplier',
        //登录页
        login:'/desktop#/login',

        //桌面页
        desktop:'/desktop#/',
        //看单打印
        lookForPrint:'/sys#',
        //价格配额
        quotaForResult:'/sys#',
        //系统管理
        system:'/sys#',
        //需求功能
        srmoem:'/srmoem',
        // 注册页
        step2:'/desktop#/step/step2',
    }
} else{                               //---生产模式---
    ngConfig={
        //登录api地址
        userLogin:'http://www.snz.com:8080',
        supplierLogin:'http://www.snz.com:8080',
        //nav(顶部导航)桌面页路径
        desktopNav:'/desktop/user',
        desktopSupplierNav:'/desktop/supplier',
        //登录页
        login:'/desktop/login',

        //桌面页
        desktop:'/desktop',
        //看单打印
        lookForPrint:'/sys',
        //价格配额
        quotaForResult:'/sys',
        //系统管理
        system:'/sys',
        //需求功能
        srmoem:'/srmoem',
        // 注册页
        step2:'/desktop/step/step2',
    }
}
export default ngConfig;



// WEBPACK FOOTER //
// ./src/config/index.js